import { Component, OnInit, forwardRef, Input, ViewChild, EventEmitter, ElementRef, Output, SimpleChanges, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgbDatepickerI18n, NgbDateParserFormatter, NgbPopover, NgbPopoverConfig, NgbDateStruct, NgbTimeStruct, NgbCalendar, NgbInputDatepicker, NgbDatepicker, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { I18n, CustomDatepickerI18n } from '../config/CustomDatePickerI18n';
import { CustomDatepickerFormat } from '../config/CustomDatePickerFormat';
import { DateTimeModel } from '../utils/models/DateTimeModel';
import { DatePipe } from '@angular/common';
import { DateTimePickerService } from './date-time-picker.service';


@Component({
	selector: 'date-time-picker',
	templateUrl: './date-time-picker.component.html',
	styleUrls: ['./date-time-picker.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => DateTimePickerComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => DateTimePickerComponent),
			multi: true,
		},
		I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }, { provide: NgbDateParserFormatter, useClass: CustomDatepickerFormat }
	]
})
export class DateTimePickerComponent implements OnInit, OnChanges, ControlValueAccessor {

	// dd/MM/yyyy HH:mm:ss
	@Input() inputDatetimeFormat: string = 'dd/MM/yyyy HH:mm'; // 'M/d/yyyy H:mm:ss'
	@Input() label: string = '';
	@Input() showLabel: boolean = true;
	@Input() readonly: boolean = false;
	@Input() required: boolean = false;
	@Input() validatorMessage: boolean = false;
	@Input() tooltipMessage: boolean = true;
	@Input() submitted: boolean = true;
	@Input() next: any;
	@Input() nextIsDisable: any;
	@Input() back: any;
	@Input() backIsDisable: any;
	@Input() openWhenFocus: boolean = false;
	@Input() goNextWhenSelect: boolean = false;
	@Output() onNext: EventEmitter<any> = new EventEmitter();
	@Output() onBack: EventEmitter<any> = new EventEmitter();


	@ViewChild('d') ngbDatepicker!: NgbInputDatepicker;
	@ViewChild('tp') timePicker!: NgbTimepicker;
	@ViewChild('btnOpen') btnOpen!: ElementRef;
	@ViewChild('btnClean') btnClean!: ElementRef;

	controls: any;
	today = this.calendar.getToday();
	date: NgbDateStruct | any = this.today;
	time: NgbTimeStruct = {
		hour: new Date().getHours(),
		minute: new Date().getMinutes(),
		second: new Date().getSeconds()
	};
	input: any = new DateTimeModel(Object.assign(this.date, this.time));
	isDisabled = false;

	constructor(private calendar: NgbCalendar, private datePipe: DatePipe,
		private dateTimePickerService: DateTimePickerService
	) {
		this.inputDatetimeFormat = this.dateTimePickerService.getInputDatetimeFormat();
		this.showLabel = this.dateTimePickerService.getShowLabel();
		this.openWhenFocus = this.dateTimePickerService.getOpenWhenFocus();
		this.goNextWhenSelect = this.dateTimePickerService.getGoNextWhenSelect();
		this.validatorMessage = this.dateTimePickerService.getValidatorMessage();
		this.tooltipMessage = this.dateTimePickerService.getTooltipMessage();
		this.submitted = this.dateTimePickerService.getSubmitted();
	}


	onChange = (_: any) => { };
	onValidationChange = () => { };
	onTouch = () => { };
	focus = () => {
		this.btnOpen.nativeElement.focus();
		if (!this.readonly && this.openWhenFocus) {
			this.ngbDatepicker.open();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.submitted) {
			if (this.controls !== undefined && changes.submitted.currentValue) {
				this.controls.markAsDirty();
				this.controls.markAsTouched();
			}
		}
	}

	ngOnInit() {

	}

	onDateSelect(evt: any) {
		//this.ngbDatepicker.close();
		// if (this.goNextWhenSelect) {
		// 	this.goNext();
		// }
		//console.log(evt);
	}

	focusOut(event: any) {
		if (event.target.ariaLabel == 'Minutes') {
			this.ngbDatepicker.close();
			if (this.goNextWhenSelect) {
				this.goNext();
			}
		}
	}

	onModelDateChange(evt: NgbDateStruct | NgbTimeStruct) {
		this.input = new DateTimeModel(Object.assign(this.date, this.time));
		const emitValue = this.datePipe.transform(this.input, 'yyyy-MM-ddTHH:mm');
		this.onTouch();
		this.onChange(emitValue);
	}

	limpiar() {
		this.date = null;
		this.time = { minute: 0, hour: 0, second: 0 };
		this.input = null;
		this.onTouch();
		this.onChange(null);
	}
	writeValue(newModel: any) {
		// this.input = new DateTimeModel(Object.assign(this.date, this.time));
		if (newModel) {
			// this.input = Object.assign(!this.input, DateTimeModel.fromLocalString(newModel));
			if (!this.input) {
				this.input = DateTimeModel.fromLocalString(newModel);
			} else {
				this.input = Object.assign(this.input, DateTimeModel.fromLocalString(newModel));
			}

			this.date = this.input;
			this.time = {
				hour: this.input.hour,
				minute: this.input.minute,
				second: this.input.second
			};
			const emitValue = this.datePipe.transform(this.input, 'yyyy-MM-ddTHH:mm');
			this.onTouch();
			this.onChange(emitValue);
		} else {
			// Agregue el limpiar para que cargue vacio si se le setea vacio o null
			this.limpiar();
			// this.input = new DateTimeModel();
		}
	}
	registerOnChange(fn: any) {
		this.onChange = fn;
	}
	registerOnTouched(fn: any) {
		this.onTouch = fn;
	}
	setDisabledState?(isDisabled: boolean) {
		this.isDisabled = isDisabled;
	}
	validate(control: AbstractControl): ValidationErrors | any {
		this.controls = control;
		return null;
	}

	registerOnValidatorChange?(fn: () => void): void {
		this.onValidationChange = fn;
	}

	open(d: NgbInputDatepicker) {
		if (this.input === null) {
			this.date = this.today;
			this.time = {
				hour: new Date().getHours(),
				minute: new Date().getMinutes(),
				second: new Date().getSeconds()
			};
			this.input = new DateTimeModel(Object.assign(this.date, this.time));
			const emitValue = this.datePipe.transform(this.input, 'yyyy-MM-ddTHH:mm');
			this.onTouch();
			this.onChange(emitValue);
		}
		//abrir el datetime
		d.open();

	}

	goNext() {
		if (this.next != undefined) {
			if (this.next.disabled || this.next.readonly) {
				if (this.nextIsDisable != undefined) {
					this.nextIsDisable.focus();
				}
			} else {
				this.next.focus();
			}
		} else {
			if (this.nextIsDisable != undefined) {
				this.nextIsDisable.focus();
			} else {
				this.onNext.emit();
			}
		}
	}

	goBack() {
		if (this.back != undefined) {
			if (this.back.disabled || this.back.readonly) {
				if (this.backIsDisable != undefined) {
					this.backIsDisable.focus();
				}
			} else {
				this.back.focus();
			}
		} else {
			if (this.backIsDisable != undefined) {
				this.backIsDisable.focus();
			} else {
				this.onBack.emit();
			}
		}
	}
}
